<lms-dynamic-form
  [title]="'students.header.info'"
  [action]="this.student ? 'students.edit' : 'students.create'"
  [options]="{ submitLabel: this.student ? 'actions.saveChanges' : 'actions.addStudent' }"
  [questions]="questions"
  (submit)="submit($event)"
>
  <ng-content select="[form-actions-before]" form-actions-before></ng-content>
</lms-dynamic-form>
